import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4587e481"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "addModuleModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "addModuleModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Add Module", -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Module name"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Target Process")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select a process", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Target Sub Process (optional)")
], -1))
const _hoisted_15 = {
  selected: "",
  value: ""
}
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Target Miletsone")
], -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select a milestone", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "AI Prompt", -1))
const _hoisted_24 = { class: "modal-footer" }
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reset())),
            "aria-label": "Close",
            ref: "closeBtn"
          }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "name",
              placeholder: "New Vendor data privacy agreement",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
              onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedProcessId) = $event))
            }, [
              _hoisted_11,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (process) => {
                return (_openBlock(), _createElementBlock("option", {
                  selected: "",
                  value: process.typeId,
                  key: process.typeId
                }, _toDisplayString(process.name), 9, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedProcessId]
            ])
          ]),
          (_ctx.subprocesses.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedSubProcessId) = $event))
                }, [
                  _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.selectedSubProcessId ? 'Deselect the' : 'Select a') + " sub process", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subprocesses, (subprocess) => {
                    return (_openBlock(), _createElementBlock("option", {
                      selected: "",
                      value: subprocess.processId,
                      key: subprocess.processId
                    }, _toDisplayString(subprocess.name), 9, _hoisted_16))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedSubProcessId]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedStepId) = $event)),
              disabled: !_ctx.selectedProcessId
            }, [
              _hoisted_20,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.milestones, (milestone) => {
                return (_openBlock(), _createElementBlock("option", {
                  selected: "",
                  value: milestone.stepId,
                  key: milestone.stepId
                }, _toDisplayString(milestone.name), 9, _hoisted_21))
              }), 128))
            ], 8, _hoisted_19), [
              [_vModelSelect, _ctx.selectedStepId]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              class: "form-control",
              id: "name",
              rows: "6",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.aiPrompt) = $event)),
              placeholder: "Write a standard operating procedure for a new vendor in relation to the data privacy agreement. Please also use a form to record the cookies used and another to record the sub processors."
            }, null, 512), [
              [_vModelText, _ctx.aiPrompt]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_ctx.showAiWaitingPrompt)
              ? (_openBlock(), _createElementBlock("p", _hoisted_25, " Unfortunately it can take up to 2 minutes until the module with the AI generated content is created. We will send you an email once it is ready. "))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary ms-2",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
              disabled: !_ctx.name.length || _ctx.submitted || !_ctx.selectedProcessId || !_ctx.selectedStepId
            }, _toDisplayString(_ctx.submitted ? "Storing" : "Create"), 9, _hoisted_26)
          ])
        ])
      ])
    ])
  ]))
}